module.exports = __webpack_public_path__ + "img/standard.52901d86.png";